import { type UseMutationResult, useMutation } from 'react-query';
import {
  ParticipantService, 
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardService_Dtos_RSUAward_AwardedParticipants,
} from '../../services/wealthlane-award-services';

const useGetRegisteredParticipantList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  setModalData: any,
  openModal: () => void
): UseMutationResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AwardService_Dtos_RSUAward_AwardedParticipants[] | undefined,
  unknown,
  void,
  unknown
> => {
  return useMutation(
    async () => {
      return await handleRequest(
        ParticipantService.getApiAwardApiAppParticipantTerminatedParticipants()
      );
    },
    {
      onSuccess: (response) => {
        if (response != null) {
          setModalData(response);
          openModal();
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default useGetRegisteredParticipantList;
